import { Grid, Typography } from '@material-ui/core';
import { OrangeButton } from 'components/Button';
import Modal from 'components/Modal';
import { SizedLongBody } from 'containers/LoginPage/styles';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';
import labels from 'utils/labels';
import useStyles from './styles';

type Props = {
  intl: IntlShape;
  open: boolean;
  setOpen: (open: boolean) => void;
};
const AddBeneficiaryHelpText = ({ open, setOpen, ...props }: Props) => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <Modal
      open={open}
      handleClose={() => setOpen(false)}
      header={
        <SizedLongBody>
          {intl.formatMessage({ id: 'addBeneficiaryHelpTitle' })}
        </SizedLongBody>
      }
      content={
        <Grid>
          <Typography className={classes.text}>
            {translate({ id: labels.addBeneficiaryHelpDescription }, props)}
          </Typography>
          <ul className={classes.list}>
            <li>
              <Typography className={classes.text}>
                {translate(
                  { id: labels.addBeneficiaryHelpDescription_marriage },
                  props,
                )}
              </Typography>
            </li>
            <li>
              <Typography className={classes.text}>
                {translate(
                  { id: labels.addBeneficiaryHelpDescription_birth },
                  props,
                )}
              </Typography>
            </li>
            <li>
              <Typography className={classes.text}>
                {translate(
                  { id: labels.addBeneficiaryHelpDescription_children },
                  props,
                )}
              </Typography>
            </li>
            <li>
              <Typography className={classes.text}>
                {translate(
                  {
                    id: labels.addBeneficiaryHelpDescription_disabled_children,
                  },
                  props,
                )}
              </Typography>
            </li>
          </ul>
        </Grid>
      }
      footer={
        <Grid container justify="flex-end">
          <Grid item>
            <OrangeButton variant="contained" onClick={() => setOpen(false)}>
              {translate({ id: labels.close }, props)}
            </OrangeButton>
          </Grid>
        </Grid>
      }
    ></Modal>
  );
};

export default injectIntl(AddBeneficiaryHelpText);
